export const subscribedContacts = state => state.subscribedContacts.items
export const subscribedContactsByReference = state =>
    (reference_type, reference_id) => {
        reference_id = parseInt(reference_id)
        return _.map(_.filter(subscribedContacts(state), {reference_type, reference_id}), 'contact_id')
    }
